// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Try again using a complete date like this: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Group',
  chart_labelSeries: () => 'Series',
  chart_labelValue: () => 'Value',
  checkboxSet_requiredMessageDetail: () => 'Required',
  checkbox_requiredMessageDetail: () => 'Required',
  close: () => 'Close',
  collection_noData: () => 'No data to display.',
  collection_selectAllRows: () => 'Select all rows',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Select row ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Not sortable',
  collection_sortEnabled: () => 'Sortable',
  confirmation: () => 'Confirmation',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' out of ' + p['totalCount'],
  dataVisualization_noData: () => 'No data to display',
  dataVisualization_stateSelected: () => 'Selected',
  dataVisualization_stateUnselected: () => 'Unselected',
  error: () => 'Error',
  expandableList_expandCollapseInstructionText: () => 'Use arrow keys to expand and collapse',
  expandableList_groupCollapse: () => 'Collapsed',
  expandableList_groupExpand: () => 'Expanded',
  filePicker_addFiles: () => 'Add Files',
  filePicker_dropzonePrimaryText: () => 'Drag and Drop',
  filePicker_dropzoneSecondaryText: () => 'Select a file or drop one here',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Select or drop files here',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    "You can't upload files of type: " + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Upload one file at a time',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    "You can't upload files of type " + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'unknown',
  formControl_clear: () => 'Clear',
  formControl_day: () => 'Day',
  formControl_helpAvailable: () => 'Help available',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'You’ve reached the limit of ' +
    (({ one: '1 character' } as Partial<Record<Intl.LDMLPluralRule, string>>)[
      new Intl.PluralRules('en').select(p['CHARACTER_LIMIT'])
    ] || new Intl.NumberFormat('en').format(p['CHARACTER_LIMIT']) + ' characters') +
    '.',
  formControl_loading: () => 'Loading',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maximum length ' + p['MAX_LENGTH'] + ' exceeded.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' characters left.',
  formControl_month: () => 'Month',
  formControl_readOnly: () => 'Read only',
  formControl_requiredMessageDetail: () => 'Enter a value.',
  formControl_year: () => 'Year',
  gantt_labelDate: () => 'Date',
  gantt_labelEnd: () => 'End',
  gantt_labelLabel: () => 'Label',
  gantt_labelRow: () => 'Row',
  gantt_labelStart: () => 'Start',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. No matching section found.',
  indexer_keyboardInstructionText: () => 'Press enter to select value.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Between ' + p['FROM_SECTION'] + ' and ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Double tap and hold to enter gesture mode, then drag up or down to adjust value.',
  info: () => 'Info',
  inputDateMask_date_cleared: () => 'Date cleared',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Empty',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'yyyy',
  inputNumber_converterParseError: () => 'Enter a number.',
  inputNumber_decrease: () => 'Decrease',
  inputNumber_increase: () => 'Increase',
  inputPassword_hidden: () => 'Password Hidden',
  inputPassword_hide: () => 'Hide Password',
  inputPassword_show: () => 'Show Password',
  list_suggestion: () => 'Suggestion',
  messageToast_allMessagesClosed: () => 'All toast messages are closed.',
  message_close: () => 'Close',
  message_confirmation: () => 'Success',
  message_error: () => 'Error',
  message_info: () => 'Info',
  message_navigationFromMessagesRegion: () =>
    'Entering messages region. Press F6 to navigate back to prior focused element.',
  message_navigationToMessagesRegion: () =>
    'Messages region has new messages. Press F6 to navigate to the most recent message region.',
  message_warning: () => 'Warning',
  noData_message: () => 'No items to display',
  overflowItemLabel: () => 'More Tabs',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'In Progress',
  radio_helpForRadio: () => 'Help for radio button',
  radio_requiredMessageDetail: () => 'Select a value.',
  selectMultiple_apply: () => 'Apply',
  selectMultiple_back: () => 'Back',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Press Backspace or Delete to remove the selected value.',
  selectMultiple_selectedValues: () => 'Selected values',
  selectMultiple_showSelectedValues: () => 'Show selected values only.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' values selected.',
  select_addToList: () => 'Add to list',
  select_addToListAvailable: () => 'Add to list available',
  select_moreSearchOptions: () => 'More search options',
  select_moreSearchOptionsAvailable: () => 'More search options available',
  select_noMatchesFound: () => 'No matches found.',
  select_oneMatchFound: () => 'One match found',
  select_requiredMessageDetail: () => 'Select a value.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' matches found',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' or more matches found',
  selector_selected: () => 'Checkbox checked',
  selector_unselected: () => 'Checkbox not checked',
  tabBarNavigationList_removeCueText: () => 'Removable',
  timeComponent_tooltipZoomIn: () => 'Zoom In',
  timeComponent_tooltipZoomOut: () => 'Zoom Out',
  train_current: () => 'Current',
  train_message_type: () => 'Message Type',
  train_not_visited: () => 'Not visited',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Step ' + p['currentStep'] + ' out of ' + p['numberOfSteps'],
  train_visited: () => 'Visited',
  userAssistance_learnMore: () => 'Learn more',
  userAssistance_required: () => 'Required',
  viz_drillable: () => 'Drillable',
  warn: () => 'Warning'
};
export default bundle;
export type BundleType = typeof bundle;
